export enum FoSalesStatus {
  Backorder = 'Backorder',
  BillSchPartialInvoiced = 'BillSchPartialInvoiced',
  Canceled = 'Canceled',
  Delivered = 'Delivered',
  Invoiced = 'Invoiced',
  None = 'None'
}
